import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const CourthouseSection = () => {
  const { language } = useLanguage();
  
  const getText = () => {
    if (language === 'ar') {
      return 'أوكل إلينا أعمالك القانونية واستشاراتك القانونية ودعاواك، فنحن فريق قانوني يتمتع بخبرة تمتد إلى (24) عامًا في العمل القانوني، ونعمل على إيجاد الحلول لمشكلاتك ونزاعاتك القانونية. إن نجاحك في دعاواك وقضاياك القانونية هو مسؤوليتنا.';
    } else if (language === 'ku') {
      return 'کارە یاساییەکان و ڕاوێژی یاسایی و داواکانت بە ئێمە بسپێرە، ئێمە وەکو تیمێکی یاسایی خاوەن ئەزمونی (24) ساڵ لە کارکردنی یاسایی چارەسەری کێشە و گرفتەکانت دەکەین، سەرکەوتنت لە داواکان و کێشە یاساییەکانت ئەرکی ئێمە.';
    }
    return 'Entrust your legal matters, legal consultations, and claims to us. We are a legal team with (24) years of experience in legal practice, dedicated to resolving your legal disputes and challenges. Your success in your claims and legal matters is our responsibility.';
  };

  return (
    <section className="py-16 bg-gradient-to-br from-gray-50 to-white relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, #c4a35a 1px, transparent 0)', backgroundSize: '40px 40px' }} />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-8 items-center max-w-6xl mx-auto">
          {/* Left - Image */}
          <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-gray-100">
            <div className="relative w-full" style={{ height: '500px' }}>
              <img
                src="/courthouse.jpg"
                alt="Presidency of Appellate Court Erbil Region"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1a1d2e]/70 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <h3 className="text-white text-xl md:text-2xl font-bold mb-2">
                  Presidency of Appellate Court - Erbil Region
                </h3>
                <p className="text-gray-200 text-sm md:text-base">
                  رئاسة محكمة استئناف منطقة أربيل | سەرۆکایەتی دادگای ئاپێڵی هەرێمی کوردستان
                </p>
              </div>
            </div>
          </div>

          {/* Right - Text Content */}
          <div className="space-y-6" style={{ direction: language === 'ar' || language === 'ku' ? 'rtl' : 'ltr' }}>
            <div className="relative">
              <div className="absolute -left-4 top-0 w-1 h-full bg-gradient-to-b from-[#c4a35a] to-transparent rounded-full" />
              <p className="text-gray-700 text-lg md:text-xl leading-relaxed font-medium">
                {getText()}
              </p>
            </div>
            
            {/* Decorative accent */}
            <div className="flex items-center gap-3 pt-4">
              <div className="w-12 h-1 bg-[#c4a35a]" />
              <div className="w-6 h-1 bg-[#c4a35a]/50" />
              <div className="w-3 h-1 bg-[#c4a35a]/25" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CourthouseSection;
